import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KebabDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"kebab_dining"}/>
}
